export default "__VITE_ASSET__36580185__"